import { useState, useEffect, useRef } from "react";
import pencil from "../../vendor/pencil.svg";
import save from "../../vendor/save.svg";

function ExpandedContainer({ item, expandedCallback }) {
  const [val, setVal] = useState(item.client_comment || '');
  const [mode, setMode] = useState("edit");
  const [iconPosition, setIconPosition] = useState(455);
  const textareaRef = useRef(null);
  const measureRef = useRef(null);

  useEffect(() => {
    if (item?.client_comment) {
      setMode("view");
    } else {
      setMode("edit");
    }
  }, [item.client_comment]);

  const adjustDimensions = () => {
    if (!textareaRef.current || !measureRef.current) return;

    textareaRef.current.style.width = "auto";
    textareaRef.current.style.height = "auto";
    measureRef.current.textContent = val || " ";
    const textWidth = measureRef.current.offsetWidth + 240;
    const parentWidth = textareaRef.current.parentElement?.offsetWidth || 0;
    const maxAllowedWidth = parentWidth;
    const optimalWidth = Math.max(490, Math.min(textWidth, maxAllowedWidth));
    textareaRef.current.style.width = `${optimalWidth}px`;

    if (textWidth > maxAllowedWidth) {
      textareaRef.current.style.whiteSpace = "pre-wrap";
      textareaRef.current.style.wordBreak = "break-word";
      textareaRef.current.style.overflowWrap = "break-word";
      textareaRef.current.style.height = "auto";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = `${scrollHeight}px`;
    } else {
      textareaRef.current.style.whiteSpace = "nowrap";
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }

    setIconPosition(optimalWidth - 35);
  };

  useEffect(() => {
    if (mode === "edit") {
      adjustDimensions();
    }
  }, [mode, val]);

  function saveComment(hasChanges = false) {
    setMode("view");

    if (hasChanges) {
      const target = { id: item.id, comment: val };
      expandedCallback(target);
    }
  }

  function editComment() {
    setMode("edit");
  }

  const handleChange = (e) => {
    setVal(e.target.value);
  };

  useEffect(() => {
    if (item.client_comment !== val) {
      setVal(item.client_comment || "");
    }
  }, [item.client_comment]);

  useEffect(() => {
    if (mode === "view" && item.client_comment) {
      setVal(item.client_comment);
    }
  }, [mode, item.client_comment]);

  return (
    <div
      className={`expanded-container ${
        mode === "view" ? "expanded-container_view" : ""
      }`}
    >
      <span
        ref={measureRef}
        style={{
          position: "absolute",
          width: "max-content",
          visibility: "hidden",
          whiteSpace: "pre",
          fontSize: "14px",
          fontFamily: "inherit",
          padding: "0",
        }}
      >
        {val}
      </span>
      {mode === "view" && val ? (
        <>
          <div className="comment-tail"></div>
          <div className="comment-text">
            Комментарий:
            <span>{val}</span>
          </div>
          <img
            className="icon expanded-icon"
            alt="Редактировать"
            title="Редактировать"
            src={pencil}
            onClick={editComment}
            style={{ marginLeft: "10px" }}
          />
        </>
      ) : (
        <div className="expanded-input">
          <textarea
            ref={textareaRef}
            id={`input-${item.id}`}
            type="text"
            value={val}
            onChange={handleChange}
            rows="1"
          />
          <label htmlFor={`input-${item.id}`}>Добавить комментарий:</label>
          <img
            type="button"
            onClick={() => {
              saveComment(val !== item.client_comment);
            }}
            className="icon expanded-icon"
            title="Сохранить"
            src={save}
            style={{
              left: `${iconPosition}px`,
              top: "calc(50% - 3px)",
              transform: "translateY(-50%)",
            }}
            alt="Сохранить"
          />
        </div>
      )}
    </div>
  );
}

export default ExpandedContainer;
